import script from "./VagasCard.vue?vue&type=script&setup=true&lang=js"
export * from "./VagasCard.vue?vue&type=script&setup=true&lang=js"

import "./VagasCard.vue?vue&type=style&index=0&id=cfb76fce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfb76fce"]])

export default __exports__